import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { Button, Box, Typography, Icon, Modal } from '@blueprint/ui';
import './HeaderComponent.css';
import hsbcLogo from '../../media/hsbcLogo.png';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logoutUser, setSuccessMessage, fetchCustomerLogo, setCaptchaHeader } from '../../actions/index';
import { useTranslation } from 'react-i18next';
import { ExpandLink } from '@blueprint/ui';
import { axiosInstance } from '../../functions/axios';

function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

const Header = () => {
    const location = useLocation();
    const [showLogout, setShowLogout] = useState(false);
    const [allowDelete, setAllowDelete] = useState(false);
    const [showDeleteBox, setShowDeleteBox] = useState(false);
    const [isOpen, setOpen] = useState(false);
    const [userName, setUserName] = useState('');
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const globalState = useSelector((state) => state);
    const logoRef = useRef();
    // API TO DELETE USER PROFILE
    const DELETE_PROFILE_URL = process.env.REACT_APP_DELETE_PROFILE_URL;
    // API TO DELETE USER PROFILE
    const FETCH_LOGO_SHORT = process.env.REACT_APP_FETCH_LOGO_SHORT;
    const [customerLogo, setCustomerLogo] = useState(null);
    const [customerLogoAltText, setCustomerLogoAltText] = useState('Customer name');
    const [custShortName, setCustShortName] = useState('');
    const search = useLocation().search;

    useEffect(() => {
        console.log('Customer short name is', custShortName);
    }, [custShortName]);

    useEffect(() => {
        console.log('LOGO checking condition, custShortname is ', custShortName);
        if (!globalState.beneDetails.details.isLogged && custShortName && (location.pathname === '/' || location.pathname === '/login' || location.pathname === '/login/signin')) {
            console.log('LOGO Fetching Logo');
            fetchLogo();
        }
        if (location.pathname !== '/' || location.pathname !== '/login') {
            setCustShortName('');
            setCustomerLogo(null);
        }
    }, [custShortName, location.pathname]);

    useEffect(() => {
        let entireURL = window.location.href;
        if (entireURL.includes('?cid=')) {
            let separatedURL = entireURL.split('?cid=');
            let cid = separatedURL[1];
            setCustShortName(cid);
        } else {
            setCustShortName('');
        }
    }, []);

    useEffect(() => {
        const body = document.getElementById('root');
        setTimeout(() => {
            if (body !== null && body !== undefined && body.length > 0) {
                console.log('Logging body', body[0]);
                body[0].focus();
            }
        }, 200);
        if (showDeleteBox === true) {
            document.getElementById('email-in-header-to-delete').click(setShowDeleteBox(false));
            setShowDeleteBox(false);
        }
    }, [location.pathname]);

    useEffect(() => {
        if (globalState.beneDetails.details.isLogged) {
            setShowLogout(true);
            setUserName(globalState.beneDetails.details.emailId);
        } else {
            setShowLogout(false);
        }
    }, [globalState]);

    useEffect(() => {
        if (globalState.beneDetails.allowDelete === true) {
            setAllowDelete(true);
        } else {
            setAllowDelete(false);
        }
    }, [globalState]);

    const logoutClicked = () => {
        try {
            dispatch(logoutUser());
        } catch (e) {
            console.log(e);
        }
        try {
            dispatch(setCaptchaHeader(null));
        } catch (e) {
            console.log(e);
        }
    };

    // DELETE API CALLED
    const callDelete = async () => {
        try {
            const response = await axiosInstance({
                method: 'post',
                url: DELETE_PROFILE_URL,
            });
            if (response.status === 200) {
                setOpen(false);
                setShowDeleteBox(false);
            }
        } catch (error) {
            if (error && error.response.status === 401) {
                setOpen(false);
                setShowDeleteBox(false);
                let data = {
                    status: 401,
                    statusText: 'User Profile has been deleted successfully.',
                };
                try {
                    dispatch(setSuccessMessage(data));
                } catch (e) {
                    console.error(`Logging store.dispatch(setSuccessMessage(data)) error`, e);
                }
            }
        }
    };

    const fetchLogo = () => {
        const fetchLogoCall = async () => {
            try {
                console.log('Logging custShortName', custShortName);

                const response = await axiosInstance({
                    method: 'get',
                    url: FETCH_LOGO_SHORT,
                    responseType: 'blob',
                    params: {
                        custShortName: custShortName,
                    },
                });
                console.log(`Logging logo from ${FETCH_LOGO_SHORT} success response`, response.data);
                if (response.status === 200) {
                    setCustomerLogo(response.data);
                    setCustomerLogoAltText(response.headers.customername);
                }
            } catch (error) {
                console.error(`Logging ${FETCH_LOGO_SHORT} error`, error);
            }
        };

        fetchLogoCall();
    };

    const logoutJSX = (
        <Box className='navbar-nav' display='flex' flexDirection='row' flexWrap='wrap' marginLeft='auto'>
            <Box className='nav-item' padding='0.5em'>
                {allowDelete ? (
                    <>
                        <ExpandLink
                            id='email-in-header-to-delete'
                            style={{ textDecoration: 'none' }}
                            onClick={() => {
                                setShowDeleteBox(!showDeleteBox);
                            }}
                        >
                            {userName}
                        </ExpandLink>
                        {showDeleteBox ? (
                            <Box className='nav-item' style={{ position: 'absolute' }} mt={2}>
                                <Button
                                    id='header-button-delete'
                                    variant='light.tertiary'
                                    onClick={() => {
                                        setOpen(true);
                                    }}
                                    style={{ zIndex: 1 }}
                                >
                                    {t('loginPage.delete')}
                                </Button>
                            </Box>
                        ) : null}
                    </>
                ) : (
                    <Typography id='email-in-header'>{userName}</Typography>
                )}
            </Box>

            <Box className='nav-item'>
                <Button
                    id='header-button-logout'
                    variant='light.secondary'
                    onClick={() => {
                        logoutClicked();
                    }}
                >
                    {t('loginPage.logoff')}
                </Button>
            </Box>
        </Box>
    );

    var showBoxShadow = false;
    if (location.pathname !== '/' && location.pathname !== '/login') {
        showBoxShadow = true;
    } else {
        showBoxShadow = false;
    }

    // useEffect(() => console.log('Customer Logo is', customerLogo), [customerLogo]);

    return (
        <Box
            backgroundColor='white'
            width='100%'
            style={{ position: 'absolute', top: '0px', left: '0px', boxShadow: showBoxShadow ? '2px 2px 5px #ededed' : '', zIndex: '1' }}
        >
            <Box
                className='navbar navbar-expand-md'
                display='flex'
                flexDirection='row'
                backgroundColor='white'
                maxWidth='1280px'
                margin='19px auto 19px auto'
                paddingLeft='5vw'
                paddingRight='5vw'
                paddingTop='0px'
                paddingBottom='0px'
            >
                <Box ref={logoRef}>
                    <img src={hsbcLogo} alt='HSBC logo' height='38px' width='auto' />
                </Box>
                {(location.pathname !== '/' || location.pathname !== '/login') && customerLogo && customerLogo.size ? (
                    <Box marginLeft='1em'>
                        <img src={URL.createObjectURL(customerLogo)} alt={customerLogoAltText+' logo'} height='30px' />
                    </Box>
                ) : null}

                {showLogout ? (
                    <Box className='navbar-toggler' data-toggle='collapse' data-target='#expandme' tabIndex='0' role='button' aria-label='Menu'>
                        <span>
                            <Icon name='MenuActive' aria-label='menu' />
                        </span>
                    </Box>
                ) : null}

                <Box className='collapse navbar-collapse' id='expandme'>
                    {showLogout ? logoutJSX : null}
                </Box>
            </Box>
            <Modal
                open={isOpen}
                onHide={() => setOpen(false)}
                closeIcon={true}
                onClickCloseIcon={() => setOpen(false)}
                size='small'
                activeFocusTrap={true}
                aria-labelledby='title1'
                minHeight='230px'
            >
                <Box display='flex' justifyContent='center' width='100%' marginTop='10%'>
                    <Box>
                        <Typography variant='h4' id='header-typo-modal-text' fontWeight='bold'>
                            {t('loginPage.delete_modal')}
                        </Typography>
                    </Box>
                </Box>
                <Box
                    position='absolute'
                    bottom='0'
                    py='1em'
                    width='calc(100% - 80px)'
                    display='flex'
                    justifyContent='space-between'
                    borderTop='1px solid #333'
                >
                    <Button variant='light.tertiary' onClick={() => setOpen(false)} id='header-button-modal-no'>
                        {t('loginPage.delete_no')}
                    </Button>
                    <Button
                        onClick={() => {
                            callDelete();
                        }}
                        id='header-button-modal-yes'
                    >
                        {t('loginPage.delete_yes')}
                    </Button>
                </Box>
            </Modal>
        </Box>
    );
};

export default Header;
